module.exports = __webpack_public_path__ + "bg-18.dd5bc245cb717a355831.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/assets/img/bg-18.jpg
// module id = ../../../../../src/assets/img/bg-18.jpg
// module chunks = 39